import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { useFeatures } from '@/contexts/root-store-context'
import { type ProfileBillingViewModel } from '@/features/iam/users/ProfileBillingViewModel'
import { PaymentMethodsSection } from '@/features/iam/users/Profile/Billing'
import { ProfilePaymentMethodsContainer } from '@/features/billing/payment-methods/ProfilePaymentMethods/ProfilePaymentMethodsContainer'

export default observer(function BillingPaymentMethodsContainer() {
  const billing = useOutletContext<ProfileBillingViewModel>()
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <PaymentMethodsSection corporateMode={shellInfo.corporateMode}>
      <ProfilePaymentMethodsContainer vm={billing.paymentMethodsVm} />
    </PaymentMethodsSection>
  )
})
